import Vue from 'vue'
import VueRouter from 'vue-router'
import { routesForProduct } from './routes'

Vue.use(VueRouter)

// The backend selects the product. Vue CLI's dev server defaults to poker.
const product = document.documentElement.dataset.product
const routes = routesForProduct(product)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
